import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import axiosInstance from "../../axios.js";
import BottomNav from "../../components/bottomNav/BottomNav";
import Feed from "../../components/feed/Feed";
import Rightbar from "../../components/rightsidebar/Rightsidebar";
import ResponsiveDrawer from "../../components/sidebar/Sidebar";
import PrimarySearchAppBar from "../../components/topbar/topbar";
import "./profile.css";

function Profile() {
  const [user, setUser] = useState({});
  const username = useParams().username;

  const PF = process.env.REACT_APP_PUBLIC_FOLDER;

  useEffect(() => {
    const fetchUser = async () => {
      const res = await axiosInstance.get(`/api/users?username=${username}`);
      setUser(res.data);
    };
    fetchUser();
  }, [username]);

  return (
    <div>
      <PrimarySearchAppBar />
      <div className="profile">
        <ResponsiveDrawer />
        <div className="profileRight">
          <div className="profileRightTop">
            <div className="profileCover">
              <img
                className="profileCoverImg"
                src={
                  user.coverPicture
                    ? PF + "/" + user.coverPicture
                    : PF + "/posts/post3.jpg"
                }
                alt=""
              />
              <img
                className="profileUserImg"
                src={
                  user.profilePicture
                    ? PF + "/" + user.profilePicture
                    : PF + "/users/noAvatar.png"
                }
                alt=""
              />
            </div>
            <div className="profileInfo">
              <h4 className="profileInfoName">{user.username}</h4>
              <span className="profileInfoDesc">{user.desc}</span>
            </div>
          </div>
          <div className="profileRightBottom">
            <Feed username={username} />
            <Rightbar user={user} />
          </div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
}

export default Profile;
